import { useCallback, useRef, useState } from 'react';

export const useChatInput = () => {
    const [messageText, setMessageText] = useState('');
    const [inputHeight, setInputHeight] = useState(40);
    const textareaRef = useRef<HTMLTextAreaElement>(null);

    const adjustInputHeight = useCallback(() => {
        if (textareaRef.current) {
            const scrollHeight = textareaRef.current.scrollHeight;
            setInputHeight(Math.min(Math.max(scrollHeight, 40), 108));
        }
    }, []);

    const handleMessageTextChange = useCallback(
        (text: string) => {
            setMessageText(text);
            adjustInputHeight();
        },
        [adjustInputHeight]
    );

    const resetInput = useCallback(() => {
        setMessageText('');
        setInputHeight(40);
    }, []);

    const focusInput = useCallback(() => {
        if (textareaRef.current) {
            textareaRef.current.focus();
        }
    }, []);

    return {
        messageText,
        setMessageText,
        inputHeight,
        textareaRef,
        adjustInputHeight,
        handleMessageTextChange,
        resetInput,
        focusInput,
    };
};
